import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import * as actions from '../actions';

class AAPlayerWrapper extends Component {
	constructor(props) {
		super(props);
		this.aaPlayer = null;
		this.aaPlayerContainer = null;
		this.readyForNextChunk = false;
	}

	componentDidMount() {
		// console.log('AAPlayerWrapper#componentDidMount()');
		const { recordingStarted, recordingStopped, playUrl, listenUrl, chunkReady, testSent } = this.props;
		// console.log(recordingStarted);
		// console.log(recordingStopped);
		// console.log(chunkReady);
		this.aaPlayer = new window.loader.components.AAPlayer({
			container: this.aaPlayerContainer,
			events: {
				onRecordStart: recordingStarted,
				onRecordFinish: recordingStopped,
				onRecordChunk: chunkReady,
			},
			playUrl,
			listenUrl
		});

		if (testSent) this.aaPlayer.prohibitRecord();
	}

	// Called each time a prop changes
	// This also includes state changed in the redux store if thos items are included in mapStateToProps
	componentDidUpdate(prevProps) {
		// console.log('AAPlayerWrapper#componentDidUpdate()');
		// console.log(this.props, prevProps);
		const { readyForNextChunk, recording, requestChunk, recordingDisabled, testSent } = this.props;
		if (readyForNextChunk && !prevProps.readyForNextChunk) {
			// console.log(`State of readyForNextChunk has changed, request the ${recording ? 'next' : 'last'} chunk`);
			requestChunk(this.aaPlayer, recording);
		}
		if (recordingDisabled && !prevProps.recordingDisabled) {
			this.aaPlayer.disableRecord();
		}
		if (!recordingDisabled && prevProps.recordingDisabled) {
			if (!testSent) this.aaPlayer.enableRecord();
		}
		if (testSent) this.aaPlayer.prohibitRecord();

		// if (!readyForNextChunk && prevProps.readyForNextChunk) {
		// 	console.log('State of readyForNextChunk has changed, NOT ready for next chunk');
		// }
	}

	render() {
		return <div className="AAPlayer" ref={(el) => this.aaPlayerContainer = el} />;
	}
}

AAPlayerWrapper.propTypes = {
	recordingStarted: PropTypes.func.isRequired,
	recordingStopped: PropTypes.func.isRequired,
	chunkReady: PropTypes.func.isRequired,
	testSent: PropTypes.bool.isRequired,
	itemIndex: PropTypes.number.isRequired, // eslint-disable-line
	playUrl: PropTypes.string,
	listenUrl: PropTypes.string,
	recording: PropTypes.bool.isRequired,
	recordingDisabled: PropTypes.bool.isRequired,
	readyForNextChunk: PropTypes.bool.isRequired,
	requestChunk: PropTypes.func.isRequired
};

AAPlayerWrapper.defaultProps = {
	playUrl: undefined,
	listenUrl: undefined,
};

const mapStateToProps = ({
	loader: { testSent, itemsKeys, itemsWithAudio },
	exercise: { readyForNextChunk, recording, recordingDisabled },
}, ownProps) => ({
	playUrl:
		itemsWithAudio[ownProps.itemIndex] ?
			`${window.NL_CONFIG.api.url}/audioanalysis/url?key=${itemsKeys[ownProps.itemIndex]}&sessionCookieName=${window.discovia.directory}` :
			undefined,
	testSent,
	readyForNextChunk,
	recording,
	recordingDisabled
});

export default compose(
	connect(mapStateToProps, actions)
)(AAPlayerWrapper);
